import { FC } from 'react';
import styled from 'styled-components';
import { Button } from '@m/alchemy-ui/Button';
import { GlobalStyles } from '@m/alchemy-ui/GlobalStyles';
import { ThemeProvider, theme, color, typeStyle, units } from '@m/alchemy-ui/theme';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #EBEDF0;
`;

const Content = styled.div`
  position: relative;
  display: inline-block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

const Header = styled.h1`
  margin-top: ${units(3)};
  margin-bottom: ${units(1.5)};
  ${typeStyle('headerM')};
`;

const SubHeader = styled.h2`
  margin-bottom: ${units(3)};
  ${typeStyle('bodyL')};
`;

const LinkButton = styled(Button)`
  ${typeStyle('subHeaderM')};
  &:hover {
    color: ${color('container')};
  }
`;

export interface ErrorPageProps {
  icon: string;
  header: string;
  subHeader: string;
  linkText: string;
  linkHref: string;
}

const NotFound: FC<ErrorPageProps> = ({
  icon,
  header,
  subHeader,
  linkText,
  linkHref,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Wrapper>
        <Content>
          <img src={icon} width={288} alt="Not Found" />
          <Header>{header}</Header>
          <SubHeader>{subHeader}</SubHeader>
          <LinkButton href={linkHref} size="large">
            {linkText}
          </LinkButton>
        </Content>
      </Wrapper>
    </ThemeProvider>
  );
};

export default NotFound;
